<template>
 
      <div class="flex flex-column pl-2 pr-2">
        <div class="mt-2 mb-2 flex align-items-center flex-column md:justify-content-between md:flex-row">
          <h2 class="">UŽÍVATELIA</h2>
          <router-link to="/admin/users/0" >
            <PrimevueButton label="Pridať užívateľa" severity="success" icon="pi pi-plus" text raised class="uppercase"/>
          </router-link>
        </div>
        <!-- <div class="card"> -->
        <DataTable 
          scrollable :scrollHeight="`${this.vh - 290}px`"
          :value="this.users"
          stripedRows
          row-hover
          v-model:selection="this.selectedUser"
          selectionMode="single"
          :metaKeySelection="false"
          @rowSelect="editUser(this.selectedUser.id)"
          tableStyle="width: 100%"
          :virtualScrollerOptions="{ itemSize: 40 }"
        >
        <!--   
          
          :totalRecords="pagination.totalRecords"
          :rowsPerPageOptions="[200,100,50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :currentPage="pagination.page"
        -->
          <Column field="lastName" header="Užívateľ" style="min-width: 18%">
            <template #body="slotProps">
              {{ slotProps.data.lastName }} {{ slotProps.data.firstName }} 
             <!--  <router-link :to="`/admin/users/${slotProps.data.id}`">{{ slotProps.data.lastName }} {{ slotProps.data.firstName }} </router-link> -->
            </template>
          </Column>

          <Column field="company" header="Spoločnosť" style="min-width: 18%">
            <!-- <template #body="slotProps">
              {{ slotProps.data.user.company }}
            </template> -->
          </Column>

          <Column field="department.name" header="Oddelenie" style="min-width: 18%">
          </Column>

          <Column field="email" header="Email" style="min-width: 18%">
          </Column>
          
          <Column field="phone" header="Telefón" style="min-width: 18%">
          </Column>
          
          <Column field="admin" header="Admin" style="min-width: 18%">
            <template #body="slotProps">
              <span v-if="slotProps.data.admin === true">Správca</span>
            </template>
          </Column>
          
          <Column header="" >
            <template #body="slotProps">
              <PrimevueButton type="button" v-tooltip.top="{ value: 'Editácia užívateľa' }" icon="pi pi-pencil" @click="editUser(slotProps.data.id)" text size="small"/>
              <!--
              <router-link :to="`/admin/users/${slotProps.data.id}`" >
                <PrimevueButton label="Upraviť" severity="info" text raised class="uppercase"/>
              </router-link>
              -->
            </template>
          </Column>

        </DataTable>
      </div>

     <!-- </div> -->




</template>

<script lang="ts">
import Security from "@/components/security";
import {store} from "@/components/store";
import router from "@/router";
import notie from "notie/dist/notie";
import PrimevueButton from 'primevue/button';
import Column from "primevue/column";

export default {
  name: "UserList",
  components: {
    PrimevueButton,
    Column,
  },
  data() {
    return {
      store,
      users: [],
      vh: 0,
      selectedUser: null,
      //pagination: {
      //  page: 1,
      //  rows: 20,
      //  totalRecords: 0, // Total number of records for pagination
      //},
      //loading: true,
    }
  },
  beforeMount() {
    //console.log("calling users")
    if (Security.requireToken()){
      store.selectModul = this.$route.path.split("/")[1]
      this.setDynamicHeight(); 
      // Aktualizácia výšky pri zmene veľkosti okna
      window.addEventListener("resize", this.setDynamicHeight);
      
      if(this.store.user.admin===false){
        router.push("/")
        notie.alert({
          type: 'error',
          text: "Na túto akciu nemáte oprávnenia"
        })
      }

      fetch(this.store.Api_url + "/v1/user?query=active:1", Security.requestOptions("GET"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
              //this.$emit('error', responseData.data);
              notie.alert({
                type: 'error',
                text: "Zoznam užívateľov sa nepodarilo načítať"
              })
            } else {
              //console.log('Users', responseData);
              this.users = responseData.data
            }
          })
          .catch((error) => {
            this.$emit('error', "Chyba pri načítaní užívateľov" + error);
          })
    }
  },

  beforeUnmount() {

    window.removeEventListener("resize", this.setDynamicHeight);
  },

  methods: {
    editUser(id:number) {
      router.push('/admin/users/' + String(id))
    },

    setDynamicHeight() {
      this.vh = window.innerHeight; // Nastavenie viditeľnej výšky
    },
  }  
  
}
</script>



<style scoped>

</style>